import { Vector4 } from "./math_types.js";

export type WebGLTextureSource = HTMLCanvasElement | ImageBitmap | HTMLImageElement | OffscreenCanvas;

export interface IWebGLAtlasAllocation
{
  uv: Vector4;
  layer: number;
}

export enum AttributeSize
{
  Float = 1,
  Vec2  = 2,
  Vec3  = 3,
  Vec4  = 4,
}

export interface IAttributeLayout
{
  location  : number;
  size      : AttributeSize;
  name      ?: string;
}

export interface ICreateTextureOptions
{
  wrap_s            ?: GLenum;
  wrap_t            ?: GLenum;
  min_filter        ?: GLenum;
  mag_filter        ?: GLenum;
  generate_mipmaps  ?: boolean;
  flip_y            ?: boolean;
}

export interface ITextureBinding
{
  location : string;
  texture  : WebGLTexture;
  unit     : number;
  target   ?: GLenum;
}

export enum BlendMode
{
  None,     // blending disabled
  Normal,   // Premultiplied: [ONE, ONE_MINUS_SRC_ALPHA]
  Additive, // Premultiplied Additive: [ONE, ONE]
  Max,      // Max blending: gl.MAX
}

export enum ColorMode
{
  Tinted  = 0, // tex.rgb * v_color * alpha (multiplies texture RGB with v_color)
  Texture = 1, // tex.rgb * alpha (pure texture RGB, ignores v_color)
  Mask    = 2, // v_color * alpha (pure color from v_color, texture only provides alpha mask)
}

export interface IRenderLayerStats
{
  active: number;
  pending: number;
}
